export default __webpack_public_path__ + "static/redhat-crw-ss-min-abe33728579af51bd502facbb7e3ce92.png";